import { __assign } from "tslib";
import React from 'react';
import { StyledTableCell } from './styled';
export var TableCell = React.forwardRef(function (props, ref) {
    return React.createElement(StyledTableCell, __assign({}, props, { ref: ref }));
});
TableCell.displayName = "TableCell";
//# sourceMappingURL=table-cell.js.map